import PropTypes from 'prop-types'
import React from 'react'
// last updated, 4/11/2021
// import resume from '../files/JosephFay_Resume.pdf'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="logo">
      <a
        className="icon fa-file-text"
        // href={resume}
        target="_blank"
        rel="noreferrer"
        // download="JosephFay_Resume"
      >
        {' '}
      </a>
    </div>
    <div className="content">
      <div className="inner">
        <h1>Joseph Fay</h1>
        <p>
          Software Developer.<span> </span>
          <br />
          Minneapolis, MN.
        </p>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('about')
            }}
          >
            About
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('work')
            }}
          >
            Work
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('passions')
            }}
          >
            Passions
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('contact')
            }}
          >
            Contact
          </button>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
